import { DatePicker } from "@ark-ui/react";
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";
import { useDatePickerCustomContext } from "../DatePickerContext";

const YearView = () => {
  const { color } = useDatePickerCustomContext();

  const activeColor = color === "primary" ? "bg-primary-500 text-white" : "bg-blue-500 text-white";

  const hoverColor = color === "primary" ? "hover:bg-primary-10" : "hover:bg-blue-10";

  return (
    <DatePicker.View view="year">
      <DatePicker.Context>
        {(datePicker) => {
          const years = datePicker.getYearsGrid().flat();
          const firstYear = years[0].label;
          const lastYear = years.slice(-1)[0].label;

          return (
            <>
              <DatePicker.ViewControl className="flex justify-between items-center py-2">
                <DatePicker.PrevTrigger>
                  <Icon path={mdiChevronLeft} size="24px" />
                </DatePicker.PrevTrigger>
                <DatePicker.ViewTrigger>
                  <span className="text-subtitle4">
                    {firstYear} - {lastYear}
                  </span>
                </DatePicker.ViewTrigger>
                <DatePicker.NextTrigger>
                  <Icon path={mdiChevronRight} size="24px" />
                </DatePicker.NextTrigger>
              </DatePicker.ViewControl>

              <DatePicker.Table className="mt-4">
                <DatePicker.TableBody>
                  {datePicker.getYearsGrid({ columns: 3 }).map((years, id) => (
                    // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                    <DatePicker.TableRow key={id}>
                      {years.map((year, id) => {
                        const selected = datePicker.valueAsDate.some((date) => date.getFullYear() === year.value);

                        return (
                          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                          <DatePicker.TableCell key={id} value={year.value} className="py-2 h-16">
                            <DatePicker.TableCellTrigger
                              className={clsx(
                                "flex justify-center items-center h-full w-[92px] rounded-8",
                                selected ? activeColor : hoverColor,
                              )}
                              asChild
                            >
                              <button type="button" className="text-label2">
                                {year.label}
                              </button>
                            </DatePicker.TableCellTrigger>
                          </DatePicker.TableCell>
                        );
                      })}
                    </DatePicker.TableRow>
                  ))}
                </DatePicker.TableBody>
              </DatePicker.Table>
            </>
          );
        }}
      </DatePicker.Context>
    </DatePicker.View>
  );
};

export default YearView;
